import React from 'react';
import { CTAButton } from './CTAButton';
import { BOX_IMAGE, CHECKOUT_URL, GUARANTEE_LINE, PRODUCT_CLAIM, PRODUCT_NAME, TOPIC_LINE } from '../data/atlante';
export function FinalCTA() {
  return <section className="border-t-8 border-gold bg-navy px-4 py-6 text-center sm:py-8" data-id="element-53" data-mp="c70vx4n7d5lx">
      <div className="mx-auto max-w-3xl" data-id="element-54" data-mp="84nqkhcdb9po">
        <p className="font-display text-[10px] font-extrabold uppercase tracking-[0.2em] text-gold sm:text-xs" data-id="element-55" data-mp="83vw59uibi0z">
          Un’ultima domanda
        </p>

        <p className="mx-auto mt-2 max-w-2xl text-[13px] font-medium leading-snug text-white/85 sm:text-[15px]" data-id="element-56" data-mp="h6dl3w1jqoro">
          Quante volte sapevi di dover consultare un riferimento per il tuo
          prossimo caso... ma hai comunque perso tempo cercando immagini,
          confronti e informazioni tra risorse diverse? Puoi continuare a passare
          da appunti, screenshot, documenti e riferimenti sparsi. Oppure puoi
          aprire un unico sistema visuale organizzato.
        </p>

        <p className="mt-2 font-display text-sm font-extrabold uppercase tracking-wide text-gold" data-id="element-57" data-mp="2c4wq2u30imk1">
          Trova l’area. Consulta il riferimento. Confronta. Analizza.
        </p>

        <h2 className="mt-3 text-xl leading-tight text-white sm:text-2xl" data-id="element-58" data-mp="2m2uaf6hr3z7d">
          🦷 {PRODUCT_NAME}
        </h2>
        <p className="mt-1 font-display text-[11px] font-extrabold uppercase tracking-wide text-white/85 sm:text-xs" data-id="element-59" data-mp="2r1nlytdh9g4w">
          {PRODUCT_CLAIM}
        </p>
        <p className="mt-0.5 text-[11px] font-bold uppercase tracking-wide text-gold" data-id="element-60" data-mp="2v38ygdm3nsek">
          {TOPIC_LINE}
        </p>

        <a href={CHECKOUT_URL} className="mt-2 block" data-id="element-61" data-mp="300978wac399d">
          <img src={BOX_IMAGE} alt="ATLANTE VISIVO DI PROTESI DENTALE™ — sistema completo" className="mx-auto w-full max-w-[170px] drop-shadow-2xl transition-transform duration-200 ease-soft hover:scale-[1.02]" data-id="element-62" data-mp="34un2myozxge1" />
        </a>

        <p className="mt-2 font-display text-[13px] font-extrabold uppercase tracking-wide text-white" data-id="element-63" data-mp="3isld3t074so9">
          🔥 OTTIENI IL SISTEMA COMPLETO OGGI
        </p>

        <CTAButton className="mx-auto mt-2 max-w-md" data-id="element-64" data-mp="1jlz448eudtqk">
          🦷 SÌ! VOGLIO {PRODUCT_NAME}
        </CTAButton>

        <p className="mt-1.5 text-[11px] font-bold text-white/80" data-id="element-65" data-mp="1sgn9rzobxdfw">
          Accesso immediato • Consegna digitale
        </p>
        <p className="mt-0.5 text-[11px] font-bold text-gold" data-id="element-66" data-mp="1npop6nwb5t6u">{GUARANTEE_LINE}</p>
      </div>
    </section>;
}